<mf-page title="Nuevo banco">
  <mf-bank
    (close)="close()"
    (save)="save($event)" />
</mf-page>
